import { Button } from '@grubhubprod/gh-cookbook-react';
import React, { ReactNode } from 'react';
import { openUrlInNewTab } from 'src/utilities/openUrlInNewTab';
import { GROCERIES_HERO_CTA_WIDTH } from 'src/components/enterprise/features/Groceries/constants/groceriesContent';

interface GroceriesOrderNowLinkButtonProps {
  children: ReactNode;
  href: string;
}

export function GroceriesOrderNowLinkButton({
  children,
  href,
}: GroceriesOrderNowLinkButtonProps): JSX.Element {
  const handleOrderNowClick = (): void => {
    openUrlInNewTab(href);
  };

  return (
    <Button
      buttonSize="medium"
      onClick={handleOrderNowClick}
      style={{ width: GROCERIES_HERO_CTA_WIDTH }}
    >
      {children}
    </Button>
  );
}
